import React from 'react';

import { ClubCmsContent } from 'src/content/club-content-consumer';
import { unwrapClubCmsRecordFromPageQuery } from 'src/content/cms-provider/club-cms-provider';

type ClubContentProviderProps = {
  children: React.ReactNode;
  clubCmsPageData: unknown;
};

const ClubContentProvider = ({ children, clubCmsPageData }: ClubContentProviderProps) => (
  <ClubCmsContent.Provider value={unwrapClubCmsRecordFromPageQuery(clubCmsPageData)}>
    {children}
  </ClubCmsContent.Provider>
);

export default ClubContentProvider;
